<mat-toolbar class="bg-white h-auto">
  <ng-container *ngIf="!loading; else mask">
    <div class="container-fluid px-0 py-1">
      <div class="row">
        <div class="col d-flex align-items-center">
          <button mat-icon-button [routerLink]="['/home/ebill']" color="accent" aria-label="EBill home" matTooltip="Home">
            <mat-icon class="fa-2x" fontIcon="fa-home" fontSet="fas"></mat-icon>
          </button>
          <mat-form-field class="ml-4 mr-2" appearance="outline">
            <mat-label>Profile Type</mat-label>
            <mat-select [(ngModel)]="profile" (selectionChange)="selectedProfile.emit(profile)" disableOptionCentering>
              <mat-option *ngFor="let type of profiles" [value]="type">{{ type.name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <section class="d-inline-block">
            <button mat-flat-button [routerLink]="['delivery']" routerLinkActive="active" color="accent">eDelivery</button>
            <button mat-flat-button class="ml-2" [routerLink]="['manage']" routerLinkActive="active" color="accent">eManage</button>
          </section>
        </div>
        <div *ngIf="isAdmin" class="col d-flex justify-content-center align-items-center">
          <button mat-flat-button color="accent" (click)="openAlternateDialog()" aria-label="Alternate ID">Alternate ID</button>
          <mat-chip-list *ngIf="impersonateId" class="pl-2 align-self-center" aria-label="user racf">
            <mat-chip [removable]="true" (removed)="alternateUser.emit('')">{{ impersonateId | uppercase }}
              <mat-icon class="text-danger" matChipRemove fontSet="fas" fontIcon="fa-times"></mat-icon>
            </mat-chip>
          </mat-chip-list>
        </div>
        <div class="col d-flex justify-content-end">
          <form [formGroup]="form" (ngSubmit)="search.emit(form.value)">
            <mat-form-field appearance="outline">
              <mat-label>Search Type</mat-label>
              <mat-select formControlName="searchType" disableOptionCentering>
                <mat-option>None</mat-option>
                <mat-option *ngFor="let searchType of searchTypes" [value]="searchType">{{ searchType.label }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="mx-sm-2">
              <input
                matInput
                formControlName="value"
                type="text"
                aria-label="bill search"
                placeholder="Search Value"
                autocomplete="off"
              />
              <button [disabled]="form.invalid || form.pristine" mat-icon-button matSuffix type="submit" class="align-bottom"
                      color="accent" aria-label="Search" matTooltip="Search">
                <mat-icon color="accent" fontIcon="fa-search" fontSet="fas"></mat-icon>
              </button>
            </mat-form-field>
            <button mat-icon-button aria-label="help" class="border border-primary" (click)="openHelpDialog()" matTooltip="Help">
              <mat-icon fontIcon="fa-question" fontSet="fas"></mat-icon>
            </button>
          </form>
        </div>
      </div>
    </div>
  </ng-container>
</mat-toolbar>

<ng-template #mask>
  <div class="w-100 d-flex align-items-end">
    <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
  </div>
</ng-template>
